
import BaseImage from '@/common/components/BaseImage.vue'
import PrintTag from '@/common/components/PrintTag.vue'
import { SVG_PLACEHOLDER_IMAGES } from '@/common/constants'
import Vue from 'vue'
import FavoriteBtn from '@/common/components/FavoriteBtn.vue'

export default Vue.extend({
  components: {
    BaseImage,
    PrintTag,
    FavoriteBtn
  },
  props: {
    alt: {
      type: String,
      required: true
    },
    productId: {
      type: String,
      required: true
    },
    itemUrl: {
      type: String,
      required: true
    },
    imageUrl: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    unit: {
      type: String,
      required: true
    },
    lead: {
      type: String,
      required: false,
      default: undefined
    },
    minPrice: {
      type: Number,
      required: false,
      default: undefined
    },
    maxPrice: {
      type: Number,
      required: false,
      default: undefined
    },
    minQuantity: {
      type: Number,
      required: false,
      default: undefined
    },
    maxQuantity: {
      type: Number,
      required: false,
      default: undefined
    },
    minCampaignPrice: {
      type: Number,
      required: false,
      default: undefined
    },
    maxCampaignPrice: {
      type: Number,
      required: false,
      default: undefined
    },
    printTag: {
      type: String,
      default: null
    },
    estimateItemId: {
      type: String,
      required: false,
      default: null
    },
    sectionName: {
      type: String,
      required: false,
      default: null
    },
    productIndex: {
      type: Number,
      required: false,
      default: null
    }
  },
  data(): {
    productEstimatedItemId: number | null
  } {
    return {
      productEstimatedItemId: null
    }
  },
  computed: {
    currentProductEstimatedItemId(): number | null {
      return this.productEstimatedItemId
    },
    currentProductId(): string {
      return this.productId
    },
    hasCampaignPrice(): boolean {
      return !!this.minCampaignPrice
    },
    placeholder(): string {
      return SVG_PLACEHOLDER_IMAGES.SQUARE
    },
    itemUrlWithTrackingParams(): string {
      if (this.sectionName && this.productIndex !== null) {
        return this.itemUrl + `?trackSourceSection=${this.sectionName}&trackSourceSectionProductIndex=${this.productIndex}&trackProductPerRow=5`
      }
      return this.itemUrl
    }
  },
  mounted() {
    const initTracking = () => {
      const productPerRow = 5

      const observer = new IntersectionObserver(entries => {
        entries.forEach((entry: any) => {
          if (entry.isIntersecting) {
            const sectionRowNumber = Math.floor((Number(this.productIndex)) / productPerRow) + 1
            const impressionData = {
              productId: this.productId,
              sectionName: this.sectionName,
              sectionRowNumber: sectionRowNumber.toString()
            }
            this.$emit('trackImpression', impressionData)
            observer.unobserve(entry.target)
          }
        })
      }, {
        root: null,
        threshold: 1
      })

      const trackedElements = document.querySelectorAll(`.cat-SectionPanel-${this.sectionName}-${this.productId}`)
      trackedElements.forEach(div => {
        observer.observe(div)
      })
    }
    if (this.sectionName) {
      initTracking()
    }
  }
})
